 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780785217367_COVER from '@/components/text/9780785217367_Cover'
 import TEXT9780785217367_ACCLAIM from '@/components/text/9780785217367_Acclaim'
 import TEXT9780785217367_BOOKS_BY from '@/components/text/9780785217367_Books_by'
 import TEXT9780785217367_TITLE from '@/components/text/9780785217367_Title'
 import TEXT9780785217367_COPYRIGHT from '@/components/text/9780785217367_Copyright'
 import TEXT9780785217367_DEDICATION from '@/components/text/9780785217367_Dedication'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780785217367_GLOSSARY from '@/components/text/9780785217367_Glossary'
 import TEXT9780785217367_PART1 from '@/components/text/9780785217367_Part1'
 import TEXT9780785217367_P1_CHAPTER1 from '@/components/text/9780785217367_P1_Chapter1'
 import TEXT9780785217367_P1_CHAPTER2 from '@/components/text/9780785217367_P1_Chapter2'
 import TEXT9780785217367_P1_CHAPTER3 from '@/components/text/9780785217367_P1_Chapter3'
 import TEXT9780785217367_P1_CHAPTER4 from '@/components/text/9780785217367_P1_Chapter4'
 import TEXT9780785217367_P1_CHAPTER5 from '@/components/text/9780785217367_P1_Chapter5'
 import TEXT9780785217367_P1_CHAPTER6 from '@/components/text/9780785217367_P1_Chapter6'
 import TEXT9780785217367_P1_EPILOGUE from '@/components/text/9780785217367_P1_Epilogue'
 import TEXT9780785217367_PART2 from '@/components/text/9780785217367_Part2'
 import TEXT9780785217367_P2_CHAPTER1 from '@/components/text/9780785217367_P2_Chapter1'
 import TEXT9780785217367_P2_CHAPTER2 from '@/components/text/9780785217367_P2_Chapter2'
 import TEXT9780785217367_P2_CHAPTER3 from '@/components/text/9780785217367_P2_Chapter3'
 import TEXT9780785217367_P2_CHAPTER4 from '@/components/text/9780785217367_P2_Chapter4'
 import TEXT9780785217367_P2_CHAPTER5 from '@/components/text/9780785217367_P2_Chapter5'
 import TEXT9780785217367_P2_CHAPTER6 from '@/components/text/9780785217367_P2_Chapter6'
 import TEXT9780785217367_P2_CHAPTER7 from '@/components/text/9780785217367_P2_Chapter7'
 import TEXT9780785217367_P2_CHAPTER8 from '@/components/text/9780785217367_P2_Chapter8'
 import TEXT9780785217367_P2_CHAPTER9 from '@/components/text/9780785217367_P2_Chapter9'
 import TEXT9780785217367_P2_CHAPTER10 from '@/components/text/9780785217367_P2_Chapter10'
 import TEXT9780785217367_P2_CHAPTER11 from '@/components/text/9780785217367_P2_Chapter11'
 import TEXT9780785217367_P2_CHAPTER12 from '@/components/text/9780785217367_P2_Chapter12'
 import TEXT9780785217367_PART3 from '@/components/text/9780785217367_Part3'
 import TEXT9780785217367_P3_CHAPTER1 from '@/components/text/9780785217367_P3_Chapter1'
 import TEXT9780785217367_P3_CHAPTER2 from '@/components/text/9780785217367_P3_Chapter2'
 import TEXT9780785217367_P3_CHAPTER3 from '@/components/text/9780785217367_P3_Chapter3'
 import TEXT9780785217367_P3_CHAPTER4 from '@/components/text/9780785217367_P3_Chapter4'
 import TEXT9780785217367_P3_CHAPTER5 from '@/components/text/9780785217367_P3_Chapter5'
 import TEXT9780785217367_P3_CHAPTER6 from '@/components/text/9780785217367_P3_Chapter6'
 import TEXT9780785217367_P3_CHAPTER7 from '@/components/text/9780785217367_P3_Chapter7'
 import TEXT9780785217367_PART4 from '@/components/text/9780785217367_Part4'
 import TEXT9780785217367_P4_CHAPTER1 from '@/components/text/9780785217367_P4_Chapter1'
 import TEXT9780785217367_P4_CHAPTER2 from '@/components/text/9780785217367_P4_Chapter2'
 import TEXT9780785217367_P4_CHAPTER3 from '@/components/text/9780785217367_P4_Chapter3'
 import TEXT9780785217367_P4_CHAPTER4 from '@/components/text/9780785217367_P4_Chapter4'
 import TEXT9780785217367_P4_CHAPTER5 from '@/components/text/9780785217367_P4_Chapter5'
 import TEXT9780785217367_P4_CHAPTER6 from '@/components/text/9780785217367_P4_Chapter6'
 import TEXT9780785217367_P4_CHAPTER7 from '@/components/text/9780785217367_P4_Chapter7'
 import TEXT9780785217367_P4_CHAPTER8 from '@/components/text/9780785217367_P4_Chapter8'
 import TEXT9780785217367_P4_CHAPTER9 from '@/components/text/9780785217367_P4_Chapter9'
 import TEXT9780785217367_P4_CHAPTER10 from '@/components/text/9780785217367_P4_Chapter10'
 import TEXT9780785217367_P4_CHAPTER11 from '@/components/text/9780785217367_P4_Chapter11'
 import TEXT9780785217367_P4_CHAPTER12 from '@/components/text/9780785217367_P4_Chapter12'
 import TEXT9780785217367_P4_CHAPTER13 from '@/components/text/9780785217367_P4_Chapter13'
 import TEXT9780785217367_DISCUSSION_QUESTIONS from '@/components/text/9780785217367_Discussion_Questions'
 import TEXT9780785217367_ACKNOWLEDGMENTS from '@/components/text/9780785217367_Acknowledgments'
 import TEXT9780785217367_ENDPAGES from '@/components/text/9780785217367_Endpages'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780785217367_Glossary",
 			"name" : "text/9780785217367_Glossary",
 			"component" : TEXT9780785217367_GLOSSARY
 		},
 		{
 			"path" : "/text/9780785217367_Part1",
 			"name" : "text/9780785217367_Part1",
 			"component" : TEXT9780785217367_PART1
 		},
 		{
 			"path" : "/text/9780785217367_P1_Chapter1",
 			"name" : "text/9780785217367_P1_Chapter1",
 			"component" : TEXT9780785217367_P1_CHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js